export const VARIABLE_CONSTANTS = {
    PREFAB_PREFIX: '$PREFAB_',
    EVENTS: ["onAbort", "onBefore", "onBeforeUpdate", "onBeforeListRecords", "onBeforeDeleteRecord", "onBeforeInsertRecord", "onBeforeUpdateRecord", "onResult", "onBeforeOpen", "onOpen", "onBeforeMessageSend", "onMessageReceive", "onProgress", "onError", "onBeforeDatasetReady", "onCanUpdate", "onClick", "onHide", "onOk", "onCancel", "onBeforeClose", "onClose", "onTimerFire", "onSuccess", "onOnline", "onOffline"],
    EVENT: {
        "CAN_UPDATE": "onCanUpdate",
        "BEFORE_UPDATE": "onBeforeUpdate",
        "BEFORE_LIST_RECORDS": "onBeforeListRecords",
        "BEFORE_DELETE_RECORD": "onBeforeDeleteRecord",
        "BEFORE_INSERT_RECORD": "onBeforeInsertRecord",
        "BEFORE_UPDATE_RECORD": "onBeforeUpdateRecord",
        "PREPARE_SETDATA": "onBeforeDatasetReady",
        "RESULT": "onResult",
        "ERROR": "onError",
        "PROGRESS": "onProgress",
        "ABORT": "onAbort",
        'CLICK': 'onClick',
        'HIDE': 'onHide',
        "OK": "onOk",
        "CANCEL": "onCancel",
        "CLOSE": "onClose",
        "TIMER_FIRE": "onTimerFire",
        "SUCCESS": "onSuccess",
        "BEFORE_OPEN": "onBeforeOpen",
        "OPEN": "onOpen",
        "BEFORE_SEND": "onBeforeMessageSend",
        "MESSAGE_RECEIVE": "onMessageReceive",
        "BEFORE_CLOSE": "onBeforeClose"
    },
    CATEGORY: {
        MODEL: 'wm.Variable',
        LIVE: 'wm.LiveVariable',
        CRUD: 'wm.CrudVariable',
        SERVICE: 'wm.ServiceVariable',
        WEBSOCKET: 'wm.WebSocketVariable',
        NAVIGATION: 'wm.NavigationVariable',
        NOTIFICATION: 'wm.NotificationVariable',
        TIMER: 'wm.TimerVariable',
        LOGIN: 'wm.LoginVariable',
        LOGOUT: 'wm.LogoutVariable',
        DEVICE: 'wm.DeviceVariable'
    },
    OWNER: {"APP": "App", "PAGE": "Page"},
    SERVICE_TYPE_JAVA: "JavaService",
    SERVICE_TYPE_MYJAVA: "MyJavaService",
    SERVICE_TYPE_REST: "RestService",
    SERVICE_TYPE_SOAP: "SoapService",
    SERVICE_TYPE_FEED: "FeedService",
    SERVICE_TYPE_DATA: "DataService",
    SERVICE_TYPE_MODEL: "ModelService",
    SERVICE_TYPE_SECURITY: "SecurityServiceType",
    SERVICE_NAME_FEED: "FeedService",
    SERVICE_TYPE_WEBSOCKET: "WebSocketService",
    SERVICE_TYPE_OPEN_API: "OpenAPIService",
    BODY_FIELD: "bodyField",
    REST_SUPPORTED_SERVICES: ["JavaService", "SoapService", "FeedService", "RestService", "SecurityServiceType", "DataService", "WebSocketService", "OpenAPIService"],
    WEB_SERVICE_VARIABLE_SERVICES: ["SoapService", "FeedService", "RestService", "WebSocketService"],
    OPEN_API_VARIABLE_SERVICE: ["OpenAPIService"],
    WEB_SERVICE_VARIABLE_WITH_NO_OPERATION: ["RestService", "WebSocketService"],
    PAGINATION_PARAMS: ["page", "size", "sort"],
    DATA_BINDING_FIELDS: ["target", "value", "type", "invalid", "isList"],
    DEFAULT_VAR: {
        "NOTIFICATION": "appNotification"
    },
    REST_SERVICE: {
        'BASE_PATH_KEY': 'x-WM-BASE_PATH',
        'RELATIVE_PATH_KEY': 'x-WM-RELATIVE_PATH',
        'OAUTH_PROVIDER_KEY': 'x-WM-PROVIDER_ID',
        'AUTH_HDR_KEY': 'Authorization',
        'SECURITY_DEFN_BASIC': 'basic',
        'SECURITY_DEFN_OAUTH2': 'oauth2',
        'AUTH_TYPE_BASIC': 'BASIC',
        'AUTH_TYPE_OAUTH': 'OAUTH2',
        'AUTH_TYPE_NONE': 'NONE',
        'CONTENT_TYPE_KEY': 'x-WM-CONTENT_TYPE',
        'ACCESSTOKEN_PLACEHOLDER': {
            'LEFT': '',
            'RIGHT': '.access_token'
        },
        'VARIABLE_TYPE': 'x-WM-VARIABLE_TYPE',
        'VARIABLE_KEY': 'x-WM-VARIABLE_KEY'
    },
    VARIABLE_SERVICE_TYPES: {
        'DATABASE': 'database',
        'WEB': 'web',
        'OPENAPI': 'openapi',
        'JAVA': 'java',
        'SECURITY': 'security',
        'DATABASE_API': 'databaseapi',
        'CUSTOM': 'custom',
        'DEVICE': 'device',
        'LOGIN': 'login',
        'LOGOUT': 'logout',
        'NAVIGATION': 'navigation',
        'NOTIFICATION': 'notification',
        'TIMER': 'timer'
    },
    VARIABLE_TO_SERVICE_TYPE_MAP: {
        'databaseapi': 'DataService',
        'java': 'JavaService',
        'security': 'SecurityServiceType'
    },
    SERVICE_TYPE_GROUP: {
        'database': 'database',
        'databaseapi': 'api',
        'web': 'api',
        'openapi': 'api',
        'java': 'api',
        'security': 'api',
        "custom": "other",
        "device": "other"
    }
};
export const SERVICE_TYPE_CONSTANTS = {
    JAVA_SERVICE: "JavaService",
    WM_JAVA_SERVICE: "wm.JavaService",
    WM_WEB_SERVICE: "wm.WebService",
    WM_DB_SERVICE: "wm.DataModel",
    WM_DB_MODEL: "wm.DataModelService",
    JAVA_SERVICE_WORKSPACE_TYPE: "javaservice",
    DEFAULT_JAVA_SERVICE_NAME: "MyJavaService",
    JAVA_SERVICE_TREE_ROOT_NODE_ICON_CLASS: "java-service",
    SECURITY_SERVICE: "Security",
    SECURITY_SERVICE_CLASS: "security-service",
    SECURITY_SERVICE_WORKSPACE_TYPE: 'securityservice',
    SECURITY_SERVICE_TYPE: "SecurityServiceType"
};
export const SWAGGER_CONSTANTS = {
    WM_DATA_JSON: 'wm_data_json',
    WM_HTTP_JSON: 'wm_httpRequestDetails',
    APP_ENVIRONMENT:"APP_ENVIRONMENT",
    PROMPT:"PROMPT",
    SERVER:"SERVER",
    VARIABLE_APP_ENV:"__APP_ENV__",

};
export const CUSTOM_HTTP_HEADERS = {
    WM_PLATFORM_VERSION: 'X-WM-Platform-Version'
}
export interface ServiceTypeGroup {
    'database': string,
    'databaseapi': string,
    'web': string,
    'openapi': string,
    'java': string,
    'security': string,
    "custom": string,
    "device": string
}
